export default {
  'meta.description': 'Delta dashboard for Delta Direct',
  'meta.title': 'Delta Direct Dashboard',
  'meta.image': `${process.env.NEXT_PUBLIC_BASE_URL}/images/delta-logo--white.svg`,
};
